
import React from 'react';
import { useEffect, useState } from 'react';
import moment from 'moment';
import { getClaimedAvcDropDownData, getClaimedAvcFareAmount,getAllViolationReason } from '../../../common/apiService';
import SelectSearch, { fuzzySearch } from 'react-select-search';
import { FaSpinner } from 'react-icons/fa';

export default function AvcInformation({ id, title, vehicletype, vechicleclass, regno, fareamount, srtlFlag, mineralMajorFlag, plazaId, entryTollPlazaId,setNewClaimedAVC,setNewDiffAmt,claimedAvc, vcClass,settleAmt,readerReadTime,caseType,violationReasonCd,onValueChange,caseStatus,commentsl,actionperforml}) {

    const [claimedavclist, setClaimedAvcList] = useState([]);
    const [mineralMajorFlagListDisabled, setMineralMajorFlagListDisabled] = useState(true);
    const [disputeAmt, setDisputeAmt] = useState('');
    const [avcDropdownVal, setAvcDropdownVal] = useState('');
    const [isDisputeAmountLoading, setIsDisputeAmountLoading] = useState(false);
    const [reasonCd, setReasonCd] = useState("");
    const [reasonLabel, setReasonLabel] = useState("");
    const [reasonList, setReasonList] = useState([]);
    const [isInfo, setIsInfo] = useState(false);

  const getClaimedVcName = (val) => {
    return `${val.concessValue} / ${val.concessDesc?.slice(0, 20)} ${
      val.concessDesc?.length > 20 ? "..." : ""
    }`;
  };
  
  useEffect(() => {
    if (plazaId && plazaId > 0) {
      const jsonData = {
        plazaId: Array.isArray(plazaId) ? plazaId.join(",") : plazaId,
        entryTollPlazaId: entryTollPlazaId || "",
      };
      getClaimedAvcDropDownData(jsonData)
        .then((res) => {
          res.data.sort((a, b) => {
            return +a.concessValue > +b.concessValue
              ? 1
              : +a.concessValue < +b.concessValue
              ? -1
              : 0;
          });
          const avcList = res.data.map((e) => ({
            name: getClaimedVcName(e),
            value: e.concessDesc + "@@" + e.concessValue,
          }));
          setClaimedAvcList(avcList);
        })
        .catch((err) => {
          setClaimedAvcList([]);
        });
      console.log("use effect 1 " + violationReasonCd);
      fetchReasonDropdown(plazaId);
    }
  }, [plazaId]);

  useEffect(() => {
    console.log("use effect ", violationReasonCd);
   if (
    violationReasonCd &&
    reasonList.length > 0 &&
    reasonList.some(opt => opt.value === violationReasonCd)
  ) {
    setReasonCd(violationReasonCd);
    let selectedReasonText=reasonList.find(item => item.value === violationReasonCd)?.name || "";
    setReasonLabel(selectedReasonText);
  }
//     setInfoFlag();
  }, [reasonList]);

    useEffect(() => {
      if ((actionperforml && caseStatus === "BackToToll") ||
          (actionperforml && caseStatus === "Reject" && commentsl?.length > 0)) {
        setIsInfo(false);
      } else {
        setIsInfo(true);
      }
    }, [actionperforml, caseStatus, commentsl,reasonList]);

//   const setInfoFlag = () => {
//     if ((actionperforml && caseStatus === "BackToToll" ) || (actionperforml && caseStatus === "Reject" && commentsl.length > 0)) {
//       setIsInfo(false);
//     } else {
//       setIsInfo(true);
//     }
//   };

  const fetchReasonDropdown = async (plazaId) => {
    try {
      const response = await getAllViolationReason(plazaId);
      const reasonList1 = response.data.map((e) => ({
        name: `${e.reasonCd} : ${e.reasonName}`,
        value: e.reasonCd,
      })); // value is code
      console.log("REASON LIST", reasonList1);
      console.log("matching reasonCD", reasonCd);
      setReasonList(reasonList1);
    } catch (error) {
      console.error("Error fetching Reason list:", error);
    }
  };

const handleReasonChange = (value) => {   // SelectSearch onChange gives value directly
  setReasonCd(value);
  console.log("value 123 "+value)
  if (onValueChange) onValueChange(value);
};
    const getDisputeAmt = (val) => {
        //setNewClaimedAVC(val);
        const vechicleClass=val.split('@@')[1];
        setNewClaimedAVC(vechicleClass);
        if(vechicleClass=='6' || vechicleClass=='7' || vechicleClass=='8' || vechicleClass=='12'|| vechicleClass=='17'){
          setMineralMajorFlagListDisabled(false);
        }else{
          setMineralMajorFlagListDisabled(true);
          //setMineralMajorFlag("No");
        }
        if (val) {
          validateFields('claimedAVC', true);
        }
        setIsDisputeAmountLoading(true)
        if(vechicleClass){
            const rrdtime = moment(readerReadTime).subtract(5, 'hours').subtract(30, 'minutes').format('YYYY-MM-DD HH:mm:ss');
            const headerJson = {
              entryTollPlazaId: entryTollPlazaId|| "",
              settlementAmt: settleAmt,
              vcClass: vcClass,
              concessVcClass: vechicleClass,
              readerReadTime: rrdtime,
              mineralMajorFlag:"",
              srtlFareFlag:srtlFlag
            }
            const bodyJson = {
              plazaId: Array.isArray(plazaId) ? plazaId.join(",") : plazaId,
            }
            calculateClaimedAVCDareAmountFun(headerJson, bodyJson);
          }

    }
    const validateFields = (key, valid) => {
        setFields(old => ({ ...old, [key]: { ...old[key], valid } }))
    }

    const [fields, setFields] = useState({
        
        claimedAVC: { valid: true, msg: "Please select Claimed AVC!" },
        
    })

    function calculateClaimedAVCDareAmountFun(headerJson, bodyjson){
        getClaimedAvcFareAmount(headerJson, bodyjson).then(res => {
          setDisputeAmt(res.data.fareAmount);
          setNewDiffAmt(res.data.fareAmount);
          setIsDisputeAmountLoading(false);
        }).catch(err => {
          setDisputeAmt(0);
          setNewDiffAmt(0);
          setIsDisputeAmountLoading(false);
        })
      }


    return (
    <div className="accordion"  id={"accordionExample"+id}>
        <div className="accordion-item">
                    <h2 className="accordion-header" id="headingOne">
                        <button className="accordion-button" style={{ backgroundColor: 'transparent',display:'block', outline: 'none !important', boxShadow: 'none',padding:'6px' }} type="button" data-bs-toggle="collapse" data-bs-target={"#" + id} aria-expanded="true" aria-controls="collapseOne">
                             <span className="infolabel">{title}</span>
                        </button>
                    </h2>
            <div id={id} className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent={"#accordionExample"+id}>
                <div className="accordion-body" style={{padding:'6px'}}>
                    <div style={{gap:'12px'}}>
                        <div>  
                            <span className="info-label"> Vehicle Class </span><br />
                            <span className="info-value">{vehicletype}</span><br /> 
                        </div>
                         
                        <div className="dislayflex">
                            <div>
                                <span className="info-label">Registration No</span><br />
                                <span className="info-value1">{regno}</span>
                            </div>
                            <div>
                                <span className="info-label">Fare Amount</span><br />
                                <span className="info-value1">{fareamount}</span>
                            </div>
                        </div>
                        <div className="dislayflex"> 
                            <div>
                                <span className="info-label"> Concessionaire Vehicle Class </span><br />
                                <span className="info-value"> {vechicleclass}</span>
                            </div>
                            { caseType && caseType==='Fare rule not available' && 
                                <div>
                                    <span className="info-label"> New Concessionaire Vehicle Class </span><br />
                                    <span className="info-value"><SelectSearch
                                        options={claimedavclist}
                                        search
                                        filterOptions={fuzzySearch}
                                        placeholder="Claimed AVC"
                                        value={avcDropdownVal}
                                        onChange={getDisputeAmt}
                                    /></span><br />
                                </div>
                            }
                        </div>
                        { isInfo && violationReasonCd && (
                        <div>
                            <span className="info-label"> Violation Reason </span><br />
                            <span className="info-value"> {reasonLabel}</span>
                        </div>)}
                        { !isInfo &&
                        <div className="vr-field">
                          <span className="info-label">Violation Reason</span><br />
                          <div className="vr-control">
                            <SelectSearch
                              options={reasonList}
                              search
                              filterOptions={fuzzySearch}
                              disabled={isInfo}
                              placeholder="Violation Reason"
                              value={reasonCd}
                              onChange={handleReasonChange}
                            />
                          </div>
                        </div>}
                        <div className='dislayflex'>
                            { caseType && caseType==='Fare rule not available' &&
                            <div>
                                    
                                    <span className="info-label">New Differential Amount</span><br />
                                    
                                    <span className="info-value1">{isDisputeAmountLoading ? <FaSpinner icon="spinner" spin className="spinner" /> : disputeAmt}</span>
                            </div>
                            }
                            {srtlFlag && srtlFlag!='None' &&
                                <div>
                                    <span className="info-label"> Mineral Major Flag</span><br />
                                    <span className="info-value"> {mineralMajorFlag || "No"}</span>
                                </div>
                            }
                        </div>

                        
                    </div>
                </div>
            </div>
        </div>
    </div>
    )
}


export function MvcInformation({ id, title, vechicleclass, regno, settlementAmount, journeyType, srtlFlag, mineralMajorFlag }) {
    return (
    <div className="accordion"  id={"accordionExample"+id}>
        <div className="accordion-item">
                    <h2 className="accordion-header" id="headingOne">
                        <button className="accordion-button" style={{ backgroundColor: 'transparent',display:'block', outline: 'none !important', boxShadow: 'none',padding:'6px' }} type="button" data-bs-toggle="collapse" data-bs-target={"#" + id} aria-expanded="true" aria-controls="collapseOne">
                          <span className="infolabel">{title}</span>
                        </button>
                    </h2>
            <div id={id} className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent={"#accordionExample"+id}>
                <div className="accordion-body" style={{padding:'6px'}}>
                    <div style={{gap:'12px'}}>
                        <div>
                            <span className="info-label"> Vehicle Class </span><br />
                            <span className="info-value"> {vechicleclass}</span>
                        </div>
                        <br/>
                        <div className="dislayflex">
                            <div>
                                <span className="info-label">Registration No</span><br />
                                <span className="info-value1">{regno}</span>
                            </div>
                            <div>
                                <span className="info-label">Settlement Amount</span><br />
                                <span className="info-value1">{settlementAmount}</span>
                            </div>
                        </div>
                        <div>
                            <span className="info-label"> Journey Type </span><br />
                            <span className="info-value"> {journeyType || "--"}</span>
                        </div>
                        { srtlFlag && srtlFlag!='None' &&
                            <div>
                                <span className="info-label"> SRTL Flag Category</span><br />
                                <span className="info-value"> {srtlFlag}</span>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
    )
}


